// ========================================
// Class Scheduling
// ========================================

const Scheduling = {
    showScheduleForm(subjectId, formationId) {
        const subject = DataManager.getSubject(subjectId);
        const formation = DataManager.getFormation(formationId);
        const professors = DataManager.getProfessors();

        if (!subject || !formation) return;

        const assignedProfessor = DataManager.getProfessor(subject.professorId);

        const content = `
            <form id="schedule-form" ${UIEvents.attr("submit", function(event,captured){Scheduling.handleSubmit(event,String(captured[0]),String(captured[1]));}, [subjectId, formationId])}>
                <p style="color: var(--text-secondary); margin-bottom: 1rem;">
                    Programar clase para: <strong>${Utils.sanitizeHTML(subject.name)}</strong><br>
                    Formación: <strong>${Utils.sanitizeHTML(formation.name)}</strong>
                </p>
                
                <div class="form-group">
                    <label class="form-label">Profesor *</label>
                    <select class="form-select" name="professorId" id="professor-select" required>
                        <option value="">Seleccionar profesor...</option>
                        ${professors.map(prof => `
                            <option value="${Utils.sanitizeHTML(prof.id)}" ${prof.id === subject.professorId ? 'selected' : ''}>
                                ${Utils.sanitizeHTML(prof.firstName)} ${Utils.sanitizeHTML(prof.lastName)} - ${StaffPay.isFixed(prof) ? 'sueldo fijo' : Utils.formatCurrency(prof.hourlyRate) + '/h'}
                            </option>
                        `).join('')}
                    </select>
                    ${assignedProfessor ? `
                        <p style="color: var(--text-secondary); font-size: 0.875rem; margin-top: 0.5rem;">
                            <i class="fas fa-info-circle"></i> Profesor asignado a esta asignatura: ${Utils.sanitizeHTML(assignedProfessor.firstName)} ${Utils.sanitizeHTML(assignedProfessor.lastName)}
                        </p>
                    ` : ''}
                </div>
                
                <div class="grid grid-2">
                    <div class="form-group">
                        <label class="form-label">Día de la Semana *</label>
                        <select class="form-select" name="dayOfWeek" id="day-select" required>
                            <option value="">Seleccionar día...</option>
                            <option value="1">Lunes</option>
                            <option value="2">Martes</option>
                            <option value="3">Miércoles</option>
                            <option value="4">Jueves</option>
                            <option value="5">Viernes</option>
                            <option value="6">Sábado</option>
                            <option value="0">Domingo</option>
                        </select>
                    </div>
                    
                    <div class="form-group">
                        <label class="form-label">Aula</label>
                        <input type="text" class="form-input" name="classroom" placeholder="Ej: Aula 101">
                    </div>
                </div>
                
                <div class="grid grid-2">
                    <div class="form-group">
                        <label class="form-label">Hora de Inicio *</label>
                        <input type="time" step="900" class="form-input" name="startTime" id="start-time" required>
                    </div>
                    
                    <div class="form-group">
                        <label class="form-label">Hora de Fin *</label>
                        <input type="time" step="900" class="form-input" name="endTime" id="end-time" required>
                    </div>
                </div>
                
                <div class="grid grid-2">
                    <div class="form-group">
                        <label class="form-label">Fecha de Inicio *</label>
                        <input type="date" class="form-input" name="startDate" required>
                    </div>
                    
                    <div class="form-group">
                        <label class="form-label">Fecha de Fin</label>
                        <input type="date" class="form-input" name="endDate">
                    </div>
                </div>
                
                <div id="conflict-warning" style="display: none; padding: 1rem; background: rgba(245, 87, 108, 0.1); border: 1px solid rgba(245, 87, 108, 0.3); border-radius: 8px; margin-top: 1rem;">
                    <p style="color: #f87171; margin: 0;">
                        <i class="fas fa-exclamation-triangle"></i> <strong>Conflicto de horario:</strong>
                        <span id="conflict-message"></span>
                    </p>
                </div>
                
                <div class="flex gap-1" style="justify-content: flex-end; margin-top: 1.5rem;">
                    <button type="button" class="btn btn-secondary" ${UIEvents.attr("click", function(event,captured){Utils.closeModal();}, [])}>
                        Cancelar
                    </button>
                    <button type="submit" class="btn btn-primary" id="submit-btn">
                        <i class="fas fa-save"></i> Programar Clase
                    </button>
                </div>
            </form>
        `;

        Utils.openModal('Programar Clase', content);

        // Add event listeners for conflict detection
        setTimeout(() => {
            const professorSelect = document.getElementById('professor-select');
            const daySelect = document.getElementById('day-select');
            const startTime = document.getElementById('start-time');
            const endTime = document.getElementById('end-time');

            const checkConflict = async () => {
                // Compare with all of this professor's classes this course, not only those on screen.
                if (professorSelect.value && typeof FileStorage !== 'undefined' && FileStorage.ensureClasses) {
                    await FileStorage.ensureClasses({ ...FileStorage.classBlockRange(FileStorage.classBlock(new Date())), professorId: professorSelect.value });
                }
                this.checkScheduleConflict(
                    professorSelect.value,
                    daySelect.value,
                    startTime.value,
                    endTime.value
                );
            };

            professorSelect.addEventListener('change', checkConflict);
            daySelect.addEventListener('change', checkConflict);
            startTime.addEventListener('change', checkConflict);
            endTime.addEventListener('change', checkConflict);
        }, 100);
    },

    checkScheduleConflict(professorId, dayOfWeek, startTime, endTime) {
        const warningDiv = document.getElementById('conflict-warning');
        const messageSpan = document.getElementById('conflict-message');
        const submitBtn = document.getElementById('submit-btn');

        if (!professorId || !dayOfWeek || !startTime || !endTime) {
            warningDiv.style.display = 'none';
            submitBtn.disabled = false;
            return;
        }

        const conflict = DataManager.checkProfessorConflict(
            professorId,
            dayOfWeek,
            startTime,
            endTime
        );

        if (conflict.conflict) {
            const professor = DataManager.getProfessor(professorId);
            const subject = DataManager.getSubject(conflict.class.subjectId);
            const formation = DataManager.getFormation(conflict.class.formationId);

            messageSpan.textContent = `${professor.firstName} ${professor.lastName} ya tiene asignada la clase "${subject ? subject.name : 'Desconocido'}" (${formation ? formation.name : 'Desconocido'}) el ${Utils.getDayName(conflict.class.dayOfWeek)} de ${conflict.class.startTime} a ${conflict.class.endTime}`;
            warningDiv.style.display = 'block';
            submitBtn.disabled = true;
        } else {
            warningDiv.style.display = 'none';
            submitBtn.disabled = false;
        }
    },

    handleSubmit(event, subjectId, formationId) {
        event.preventDefault();
        const formData = new FormData(event.target);
        const data = Object.fromEntries(formData);

        // Validate times
        if (data.startTime >= data.endTime) {
            Utils.showToast('La hora de inicio debe ser anterior a la hora de fin', 'error');
            return;
        }

        // Final conflict check
        const conflict = DataManager.checkProfessorConflict(
            data.professorId,
            data.dayOfWeek,
            data.startTime,
            data.endTime
        );

        if (conflict.conflict) {
            Utils.showToast('Existe un conflicto de horario con otra clase', 'error');
            return;
        }

        // Create class
        data.subjectId = subjectId;
        data.formationId = formationId;

        DataManager.createClass(data);
        Utils.closeModal();
        Utils.showToast('Clase programada correctamente', 'success');

        // Refresh view
        App.navigate(App.currentView || 'formaciones');
    }
};

// Make Scheduling globally available
window.Scheduling = Scheduling;
